import { httpClient } from './api/httpClient';
import { isMockEnabled } from './api/mockAdapter';
import { API_ENDPOINTS } from 'constants/apiEndpoints';

export const toActivityLog = (raw) =>
  raw && {
    id: raw.id,
    module: raw.module,
    operation: raw.operation,
    referenceId: raw.reference_id ?? raw.referenceId ?? '',
    referenceName: raw.reference_name ?? raw.referenceName ?? '',
    description: raw.description,
    performedBy: raw.performed_by ?? raw.performedBy ?? '',
    performedByName: raw.performed_by_name ?? raw.performedByName ?? '',
    metadata: raw.metadata ?? {},
    createdAt: raw.created_at ?? raw.createdAt ?? null,
  };

export const activityLogService = {
  async list(params = {}) {
    if (isMockEnabled()) {
      return { items: [], total: 0, page: 1, pageSize: params.page_size ?? 20, totalPages: 0 };
    }
    const data = await httpClient.get(API_ENDPOINTS.ACTIVITY_LOGS.LIST, { params });
    const items = (data.items ?? []).map(toActivityLog);
    return {
      items,
      total: data.total ?? items.length,
      page: data.page ?? 1,
      pageSize: data.page_size ?? params.page_size ?? 20,
      totalPages: data.total_pages ?? 1,
    };
  },
};

export default activityLogService;
